import { render, staticRenderFns } from "./storage-manage-index.vue?vue&type=template&id=fb044050"
import script from "./storage-manage-index.vue?vue&type=script&lang=js"
export * from "./storage-manage-index.vue?vue&type=script&lang=js"
import style0 from "./storage-manage-index.vue?vue&type=style&index=0&id=fb044050&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports